module.exports = __webpack_public_path__ + "static/media/bullet-activ.521519f0.png";